<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" fxLayout="column" fxFill>
  <div class="content_container" fxLayout="row">
    <as-split direction="horizontal">
      <as-split-area [size]="40" [minSize]="30">
        <div class="new_list_container mat-elevation-z0" fxLayout="column">
          <!-- header -->
          <div class="new_header_container" fxLayout="row" fxLayoutAlign="start center">
            <span class="subtitle" i18n="@@employeeGroupsLabel">Employee Groups</span>
            <div class="expand"></div>
            <button
              id="add_new_employee_group"
              class="add-button"
              color="secondary"
              mat-icon-button
              type="button"
              aria-label="new employee"
              *epgIfPermitted="[OneAppPermission.EMPLOYEE_WRITE]"
              (click)="onNewEmployeeGroupClick()"
            >
              <fa-icon class="icon" [icon]="faPlus" aria-label="user settings button"></fa-icon>
            </button>
          </div>
          <mat-divider></mat-divider>

          <mat-form-field class="search_field" appearance="outline">
            <mat-label i18n="@@searchTitle">Search</mat-label>
            <fa-icon
              matSuffix
              class="search-icon"
              [icon]="faSearch"
              aria-label="user settings button"
            ></fa-icon>
            <input type="text" matInput [(ngModel)]="searchText" />
          </mat-form-field>

          <div id="employee_group_item_container" class="new_list_item_container">
            <div
              class="new_list_item"
              *ngFor="let empGroup of employeeGroups | employeeGroupSearch : searchText"
              [routerLink]="empGroup.employeeGroupId"
              routerLinkActive="active_item"
            >
              <div>
                {{ empGroup?.name }}
              </div>
            </div>
            <div
              *ngIf="employeeGroups.length === 0"
              fxFill
              fxLayoutAlign="center"
              class="employee_groups_empty_list"
            >
              <span i18n="Employee groups list is empty header@@employeeGroupsEmptyList"
                >No employee groups to display.</span
              >
            </div>
          </div>
        </div>
      </as-split-area>

      <as-split-area [size]="60" [minSize]="30">
        <div class="detail">
          <router-outlet></router-outlet>
        </div>
      </as-split-area>
    </as-split>
  </div>
</div>
